// Iconos de línea acordes al diseño de Claude Design (Figma) de ZOCO.
export const IconClock = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm.9-13h-1.8v6l5 3 .9-1.5-4.1-2.4V7Z" />
  </svg>
);

export const IconCalendarPlain = ({ size = 26 }) => (
  <svg width={size} height={size * 0.92} viewBox="0 0 25 23" fill="none" stroke="currentColor" aria-hidden="true">
    <rect x="1" y="3" width="23" height="19" rx="2.5" strokeWidth="1.6" />
    <path d="M1 8.5h23M7 1v4M18 1v4" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export const IconTrash = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
    <path d="M4 7h16M9 7V5a1.5 1.5 0 0 1 1.5-1.5h3A1.5 1.5 0 0 1 15 5v2M6 7l1 13a1.5 1.5 0 0 0 1.5 1.4h7A1.5 1.5 0 0 0 17 20L18 7" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10 11v6M14 11v6" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export const IconPencil = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
    <path d="M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17v3Z" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.5 6.5 17.5 9.5" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);
